import store from "../store";


export const proposalListSelectors = {
	content: (state = store.getState()) => state.proposals.content,
	summary: (state = store.getState()) => state.proposals.summary,
};
